import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import aduWorthItImage from '@/assets/adu-worth-it.jpg';

const IsADUWorthItCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/is-adu-worth-it-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={aduWorthItImage} 
              alt="Family enjoying ADU value" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Is an ADU Worth It in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Evaluate if building an ADU in California is a worthy investment. Analyze potential benefits, income, and added property value.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Financial Advantages of ADUs
              </h2>
              <p className="text-white leading-relaxed mb-6">
                ADUs in California offer substantial financial benefits including rental income potential of $1,500-$4,000+ monthly, depending on location. Construction costs typically range from $150,000-$400,000, with many homeowners seeing return on investment within 7-12 years through rental income and increased property value.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                How ADUs Impact Property Value in California
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Studies show ADUs can increase property values by 20-30% in California markets. Beyond immediate value gains, ADUs provide long-term appreciation benefits, enhanced marketability, and appeal to buyers seeking multi-generational living options or investment income potential.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Long-term Benefits of Building an ADU
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Long-term ADU advantages include passive rental income, housing flexibility for aging parents or adult children, potential tax benefits, and increased borrowing capacity against home equity. ADUs also provide recession-resistant income streams and adapt to changing family needs over time.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Do ADUs significantly increase home value in California?</p>
                  <p>A: Yes, ADUs commonly enhance property value and potential rental income.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: What are long-term advantages of building an ADU?</p>
                  <p>A: Increased equity, rental income, flexible living space, and multigenerational living options.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default IsADUWorthItCalifornia;